const envSource = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : (typeof process !== 'undefined' && process.env) ? process.env : {};

const required = ['VITE_SUPABASE_URL', 'VITE_SUPABASE_ANON_KEY'];

const missing = required.filter((key) => !envSource[key]);

if (missing.length > 0 && typeof window !== 'undefined') {
  console.warn(`Missing Vite env values: ${missing.join(', ')}`);
}

export const env = {
  supabaseUrl: envSource.VITE_SUPABASE_URL || '',
  supabaseAnonKey: envSource.VITE_SUPABASE_ANON_KEY || '',
};
